import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { PaymentCard } from 'models/paymentCard';
import { getFlagByAlpha2 } from 'services/countriesService';
import { cardTypeNormalize } from 'utils/payment';

import { Flag } from './styles';

export interface Props {
  card: PaymentCard;
}

const PaymentCardFlag = ({ card }) => {
  const [flagImage, setFlagImage] = useState('');
  let { card_type } = card;
  card_type = cardTypeNormalize(card_type);
  const card_image = useMemo(
    () =>
      card_type.match(/master|amex|visa/gi) === null
        ? '/images/payment/cc/payment.svg'
        : `/images/payment/cc/${card_type.toLowerCase()}.svg`,
    [card_type],
  );

  const getCardImage = useCallback(async () => {
    if (card.country_code.match(/ar|br|cl|co|cr|ec|pr|mx|ur/gi) !== null) {
      setFlagImage(`/images/payment/country/${card.country_code.toLowerCase()}.svg`);
    }
    try {
      const { flag } = await getFlagByAlpha2(card.country_code);
      const els = document.querySelectorAll(`[data-flag-id="${card.country_code}"]`);
      for (const el in els) {
        els[el].setAttribute('style', `background-image: url(${flag})`);
      }
    } catch (e) {}
  }, [card.country_code]);

  useEffect(() => {
    getCardImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flag data-test-id={card.country_code}>
      <Flag.Icon src={card_image} alt={card_type} />
      {flagImage !== '' ? (
        <Flag.Image src={flagImage} data-flag-id={card.country_code}></Flag.Image>
      ) : (
        <Flag.Image data-flag-id={card.country_code}></Flag.Image>
      )}
    </Flag>
  );
};

export default PaymentCardFlag;
